var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMentalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 10.0002C16.2418 8.7835 17.5002 7.32516 17.5002 5.41683C17.5002 4.20125 17.0173 3.03547 16.1577 2.17592C15.2982 1.31638 14.1324 0.833496 12.9168 0.833496C11.4502 0.833496 10.4168 1.25016 9.16683 2.50016C7.91683 1.25016 6.8835 0.833496 5.41683 0.833496C4.20125 0.833496 3.03547 1.31638 2.17592 2.17592C1.31638 3.03547 0.833496 4.20125 0.833496 5.41683C0.833496 7.3335 2.0835 8.79183 3.3335 10.0002L9.16683 15.8335L15.0002 10.0002Z",
    stroke: "#846277",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMentalIcon);
export default __webpack_public_path__ + "static/media/footer_mental_icon.45c710f187f17f36ad1ee1c19a1220b7.svg";
export { ForwardRef as ReactComponent };